import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormFieldConfigHeader = ({
  label
}) => {
  return /*#__PURE__*/_jsx(View, {
    paddingInlineStart: "600",
    paddingBlockStart: "500",
    paddingInlineEnd: "200",
    children: /*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: label
    })
  });
};